import { render, staticRenderFns } from "./user-home-page.component.vue?vue&type=template&id=7bf3b154&"
import script from "./user-home-page.component.ts?vue&type=script&lang=ts&"
export * from "./user-home-page.component.ts?vue&type=script&lang=ts&"
import style0 from "./user-home-page.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports